import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { auth0WebAuth } from 'modules/boot/sso';
import { SocialButtonsPane, SignupPane } from '../';

const pushDataLayer = (eventLabel) => {
  if (typeof window === 'undefined') {
    return;
  }
  window.dataLayer = window && window.dataLayer || [];
  window.dataLayer.push({
      'event': 'gaEvent',
      'eventCategory': 'Sign up',
      'eventAction': 'Identity Submit',
      'eventLabel': eventLabel
  });
}

class SignupForm extends Component {
  state = {
    onClickGithubProvider: () => {},
    onClickGoogleProvider: () => {},
    onClickMicrosoftProvider: () => {},
    onClickDatabaseProvider: () => {},
    isPaidMedia: false,
  };

  componentDidMount() {
    this.clientInitialize();
    if (window.sessionStorage) {
      this.setState({ isPaidMedia: window.sessionStorage.getItem('paidMedia') === 'true' });
    }
  }

  clientInitialize() {
    const { dbConnectionName } = this.props;
    this.setState({
      onClickGithubProvider: () => {
        pushDataLayer('GitHub');
        return auth0WebAuth.authorize({ connection: 'github' });
      },
      onClickGoogleProvider: () => {
        pushDataLayer('Google');
        return auth0WebAuth.authorize({ connection: 'google-oauth2' });
      },
      onClickMicrosoftProvider: () => {
        pushDataLayer('Windows');
        return auth0WebAuth.authorize({ connection: 'windowslive' });
      },
      onClickDatabaseProvider: (username, password, onError) => {
        auth0WebAuth.redirect.signupAndLogin(
          {
            email: username,
            password,
            connection: dbConnectionName
          },
          onError
        );
      }
    });
  }

  render() {
    const { ispEmail, forceWorkEmail } = this.props;
    const { isPaidMedia } = this.state;

    return (
      <div>
        <div className="form-box">
          <form className="sign-up-form" method="post">
            <SignupPane
              onSignup={this.state.onClickDatabaseProvider}
              ispEmail={ispEmail}
              forceWorkEmail={forceWorkEmail || isPaidMedia}
            />
            
            {(!forceWorkEmail && !isPaidMedia) && (
            <React.Fragment>
              <div className="copy-separate">
                <p>or</p>
              </div>
              <SocialButtonsPane
                onClickGithubProvider={this.state.onClickGithubProvider}
                onClickGoogleProvider={this.state.onClickGoogleProvider}
                onClickMicrosoftProvider={this.state.onClickMicrosoftProvider}
              />
            </React.Fragment>
            )}
          </form>
        </div>
      </div>
    );
  }
}

SignupForm.propTypes = {
  dbConnectionName: PropTypes.string.isRequired,
  ispEmail: PropTypes.string,
};

SignupForm.defaultProps = {
  ispEmail: '',
};

export default SignupForm;



// WEBPACK FOOTER //
// ./src/modules/signupForm/components/SignupForm/SignupForm.js